import React, { Component } from 'react'
import './select.scss'
import SectionContentTypes from "./ContentTypes.jsx";
import Icon from "../../../common/icon/icon.component.jsx"
import { AppContext, AccountFeatures } from '@lightspeed-invoicing/core-client/frontend';
import ButtonWrapper from '../../../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component'

class ContentTypeSelector extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            type: this.props.type || 'quote',
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
            contentType: this.props.value || '',
            mobile: this.props.mobile || false,
        }
    }

    componentDidMount() {

    }

    getContentTypes() {
        return SectionContentTypes.getAll(this.state.type, this.state.contentType)
    }

    selectContentType(id) {
        return function (e) {
            e.preventDefault()
            this.setState({
                contentType: id,
            }, () => {
                this.state.onChange(id)
            })
        }.bind(this)
    }

    render() {
        return (
            <div className="row content-type-selector">
                <div className="col-12">
                    <div className="d-flex align-content-stretch flex-wrap">
                        {this.getContentTypes()
                            .filter(c => c.mandatory === false && c.disabled !== true)
                            .map(c => {
                                let className = "card "
                                if (this.state.contentType === c.id) {
                                    className += " bg-primary text-white"
                                }
                                let accountFeatureKey = ''
                                if (c.premiumOnly) {
                                    if (c.id === 'signature') {
                                        accountFeatureKey = AccountFeatures.FeatureDigitalSignature
                                    } else if (c.id === 'payment') {
                                        accountFeatureKey = AccountFeatures.FeatureRemovePaymentButton
                                    }
                                }
                                return <div key={c.id} className="align-self-stretch p-1">
                                    <div className={className}>
                                        <div className={'card-body p-0'}>
                                            <h6 className="card-title mb-0">
                                                <span className="text-center mb-0">
                                                    <ButtonWrapper
                                                        onClick={this.selectContentType(c.id)}
                                                        isProtected={c.premiumOnly || false}
                                                        accountFeatureKey={accountFeatureKey}
                                                        redirectToAccount={true}
                                                        key={c.id}
                                                        className="btn btn-link">
                                                        {c.icon} {c.name}
                                                    </ButtonWrapper>
                                                </span>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            })}
                    </div>
                </div>
                <div className="col-lg-6 col-md-12">
                    {this.getContentTypes().map(c => {
                        let className = ""
                        if (this.state.contentType === c.id) {
                            className += " show"
                        } else {
                            className += " d-none"
                        }
                        return <div key={c.id} className={className} id={"list-" + c.id} role="tabpanel"
                            aria-labelledby={"list-" + c.id + "-list"}>
                            <p className="p-2 m-0" >{c.description}</p>
                        </div>
                    })}
                </div>
            </div>
        );
    }
}

export default ContentTypeSelector


// WEBPACK FOOTER //
// ./src/template/sections/content/select.component.jsx